module.exports = __webpack_public_path__ + "img/shoppimgcar01.7b44e3ae.png";